import { http } from './http'

// 获取用户信息
export const getUserInfo = () =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user',
        method: 'get',
        alert: false,
        // query: params,
    })